import { TabPageDefinition } from '@/components/tab-pages';

export const lessonsSectionTabs = (): TabPageDefinition[] => {
  return [
    {
      label: 'All Lessons',
      linkProps: {
        to: '/lessons',
      },
    },
    {
      label: 'Learning Paths',
      linkProps: {
        to: '/lessons/learning-paths',
      },
    },
    {
      label: 'Assessments',
      linkProps: {
        to: '/lessons/assessments',
      },
    },
    {
      label: 'Assessment Contents',
      linkProps: {
        to: '/lessons/assessment-contents',
      },
    },
  ];
};
